export const blockInvalidChar = e => ['+', '-'].includes(e.key) && e.preventDefault();